import { supabase } from '../lib/supabaseClient';
import { isDemoMode } from '../demo/demoMode';

// 견적요청 부가정보(사이드카) 조회.
// hanmaeum 이 상담저장 SP 로는 전달하지 못하는 값(여행지 도시, 추후 일정표 JSON 등)을
// estimate_extras 테이블에 상담번호를 키로 저장해 둔다. 여기서 같은 상담번호로 읽어온다.
//
// ⚠ 부가 기능이다. Supabase 미설정/조회 실패 시 null 을 반환하고, 상담상세는
//    SP 데이터만으로 정상 표시되어야 한다(흐름을 막지 말 것).
export const getEstimateExtras = async (consultNo) => {
  const no = Number(consultNo);
  if (!no) return null;
  // 데모 모드에서는 Supabase 로 나가지 않는다. 인터셉터는 ERP 호스트만 막기 때문이다.
  if (isDemoMode()) return null;
  if (!supabase) return null; // 미설정 시 조용히 skip

  try {
    const { data, error } = await supabase
      .from('estimate_extras')
      .select('extras')
      .eq('상담번호', no)
      .maybeSingle();
    if (error) {
      console.warn('[estimateExtras] 부가정보 조회 실패(무시):', error.message);
      return null;
    }
    return data?.extras ?? null;
  } catch (e) {
    console.warn('[estimateExtras] 부가정보 조회 예외(무시):', e);
    return null;
  }
};
